import { configureStore, combineReducers  } from '@reduxjs/toolkit';
//import storage from 'redux-persist/lib/storage';
import storageSession from 'redux-persist/lib/storage/session'
import { persistReducer, persistStore } from 'redux-persist';
import { encryptTransform } from 'redux-persist-transform-encrypt';
//import { thunk } from 'redux-thunk';

import { alertReducer } from './alert.slice';
import { authReducer } from './auth.slice';
import { usersReducer } from './users.slice';
import { customersReducer } from './customers.slice';
import { userProjectsReducer } from './user_projects.slice';
import { fullProfilesReducer } from './full_profiles.slice';
import { masterProfilesReducer } from './master_profiles.slice';
import { discoveryReducer } from './discovery.slice';
import { breadcrumbsReducer } from './breadcrumbs.slice';
import { inquiriesReducer } from './inquiries.slice';
import { specialitiesReducer } from './specialities.slice';

export * from './alert.slice';
export * from './auth.slice';
export * from './users.slice';
export * from './customers.slice';
export * from './user_projects.slice';
export * from './full_profiles.slice';
export * from './master_profiles.slice';
export * from './discovery.slice';
export * from './breadcrumbs.slice';
export * from './inquiries.slice';
export * from './specialities.slice';

const secretKeyForLocalStorage = 'my-super-secret-key-is-always-secret-for-cs';

const rootPersistConfig = {
    key: 'root',
    storage: storageSession,
    whitelist: ['auth','breadcrumbs'],
    blacklist: ['users'],
    transforms: [encryptTransform({
        secretKey: secretKeyForLocalStorage,
        onError: function(error) {
            // handle the error
        }
    })]
};

const authPersistConfig = {
    key: 'auth',
    storage: storageSession,
    transforms: [encryptTransform({
        secretKey: secretKeyForLocalStorage,
        onError: function(error) {
            // handle the error
        }
    })]
};

const persistedAuthReducer = persistReducer(authPersistConfig, authReducer);

const rootReducer = combineReducers(
    {
        alert: alertReducer,
        auth: persistedAuthReducer,
        users: usersReducer,
        customers: customersReducer,
        userProjects: userProjectsReducer,
        fullProfiles: fullProfilesReducer,
        masterProfiles: masterProfilesReducer,
        discovery: discoveryReducer,
        breadcrumbs: breadcrumbsReducer,
        inquiries: inquiriesReducer,
        specialities: specialitiesReducer
    }
);

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);


export const store = configureStore({
    reducer: persistedReducer,
    devTools: false,
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        serializableCheck: false
    })
});

export const persistor = persistStore(store)